import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { DateCalendar } from '../DateCalendar';
import { jsx as _jsx } from "react/jsx-runtime";
const isDatePickerView = view => view === 'year' || view === 'month' || view === 'day';
export const renderDateViewCalendar = props => /*#__PURE__*/_jsx(DateCalendar, _extends({}, props, {
  view: props.view,
  views: props.views.filter(isDatePickerView),
  focusedView: props.focusedView
}));